// extracted by mini-css-extract-plugin
export default {"imgAndTextFlow":"index_imgAndTextFlow_TIOoL"};